<div class="card m-0 rounded rounded-3">
    <div class="card-header d-flex justify-content-between align-items-center">
        <h5 class="card-title mb-0 text-white" id="aboutModalLabel">Change Password</h5>
        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
    </div>
    <div class="card-body">
        <form [formGroup]="changePasswordForm!" #PasswordForm="ngForm">
            <request-validation [entity]="data"></request-validation>
            <app-unsaved-changes [formName]="changePasswordForm"></app-unsaved-changes>
            <div class="form-group mb-3" [ngClass]="{'has-danger':  changePasswordForm!.controls.oldPassword.errors?.required}">
                <label for="oldPassword">Current Password<span class="required-denote">*</span></label>
                <input type="password" [(ngModel)]="data.OldPassword" class="form-control" formControlName="oldPassword" required>
                <div class="form-control-feedback" *ngIf="changePasswordForm!.controls.oldPassword?.errors?.required && submitted">Current Password is required!
                </div>
            </div>
            <div class="form-group mb-3" [ngClass]="{'has-danger': changePasswordForm!.controls.newPassword.errors?.required || changePasswordForm!.controls.newPassword.errors?.pattern}">
                <label for="newPassword">New Password<span class="required-denote">*</span></label>
                <div class="input-group">
                    <input type="{{ptype}}" (click)="showList()" [(ngModel)]="data.NewPassword" (ngModelChange)="inputChange($event)" formControlName="newPassword" pattern="^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_]).{8,}$" class="form-control bg-transparent" minlength="6" required>
                    <button class="btn btn-link text-decoration-none" type="button" (click)="showHidePassword()" id="password-addon">
            <i class="mdi align-middle"
              [ngClass]="showPassword ?'mdi-eye-outline':'mdi-eye-off-outline'"
              ></i>
          </button>
                </div>
                <ul class="password-hint" *ngIf="show">
                    <li style="width:300px; font-size:13px; list-style:none;">Password needs at least:</li>
                    <li *ngFor="let rule of getPasswordChecks()">
                        <i class="me-1 password-icon" [ngClass]="rule.passed ? 'fa fa-check text-success' : 'fa fa-times text-danger'"></i>
                        <span>{{ rule.label }}</span>
                    </li>
                </ul>
                <div class="form-control-feedback" *ngIf="changePasswordForm!.controls.newPassword?.errors?.required && submitted">New Password is required!
                </div>
            </div>
            <div class="form-group mb-3" [ngClass]="{'has-danger':  changePasswordForm!.controls.confPassword.errors?.required}">
                <label>Confirm Password<span class="required-denote">*</span></label>
                <div class="input-group">
                    <input [(ngModel)]="data.ConfirmPassword" type="{{cptype}}" formControlName="confPassword" (click)="hideList()" class="form-control  bg-transparent" required>
                    <button class="btn btn-link text-decoration-none" type="button" (click)="showHideConfPassword()" id="password-addon">
            <i class="mdi align-middle"
              [ngClass]="showConfPassword ?'mdi-eye-outline':'mdi-eye-off-outline'"
             ></i>
          </button>
                </div>
                <p class="form-control-feedback text-danger" *ngIf="changePasswordForm!.errors?.doesMatchPassword">Password does not match
                </p>
            </div>
        </form>
    </div>
    <div class="card-footer d-flex justify-content-between">
        <div></div>
        <div class="">
            <button type="submit" [ladda]="isUpdating" class="btn btn-primary" [disabled]="!PasswordForm.valid" (click)="submit(changePasswordForm!.valid)">Update</button>
            <button type="button" class="btn btn-dark ms-2" data-bs-dismiss="modal" (click)="activeModal.dismiss('Cross click')">Close</button>
        </div>
    </div>
</div>